import { render, staticRenderFns } from "./SimpleImageUploader.vue?vue&type=template&id=24e21402&scoped=true"
import script from "./SimpleImageUploader.vue?vue&type=script&lang=js"
export * from "./SimpleImageUploader.vue?vue&type=script&lang=js"
import style0 from "./SimpleImageUploader.vue?vue&type=style&index=0&id=24e21402&prod&lang=scss"
import style1 from "./SimpleImageUploader.vue?vue&type=style&index=1&id=24e21402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e21402",
  null
  
)

export default component.exports